"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx2 = _interopRequireDefault(require("clsx"));

var _styles = require("@material-ui/styles");

var _core = require("@material-ui/core");

var _excluded = ["className", "variant", "color", "shape", "children", "style"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexGrow: 0,
      flexShrink: 0,
      borderRadius: theme.shape.borderRadius,
      lineHeight: '10px',
      fontSize: '10px',
      height: 20,
      minWidth: 20,
      whiteSpace: 'nowrap',
      padding: theme.spacing(0.5, 1)
    },
    rounded: {
      borderRadius: 10,
      padding: theme.spacing(0.5)
    }
  };
});

var Label = function Label(props) {
  var _clsx;

  var className = props.className,
      variant = props.variant,
      color = props.color,
      shape = props.shape,
      children = props.children,
      style = props.style,
      rest = _objectWithoutProperties(props, _excluded);

  var classes = useStyles();
  var rootClassName = (0, _clsx2["default"])((_clsx = {}, _defineProperty(_clsx, classes.root, true), _defineProperty(_clsx, classes.rounded, shape === 'rounded'), _clsx), className);

  var finalStyle = _objectSpread({}, style);

  if (variant === 'contained') {
    finalStyle.backgroundColor = color;
    finalStyle.color = '#FFF';
  } else {
    finalStyle.border = "1px solid ".concat(color);
    finalStyle.color = color;
  }

  return /*#__PURE__*/_react["default"].createElement(_core.Typography, _extends({}, rest, {
    className: rootClassName,
    style: finalStyle,
    variant: "overline"
  }), children);
};

Label.propTypes = {
  children: _propTypes["default"].node,
  className: _propTypes["default"].string,
  color: _propTypes["default"].string,
  shape: _propTypes["default"].oneOf(['square', 'rounded']),
  style: _propTypes["default"].object,
  variant: _propTypes["default"].oneOf(['contained', 'outlined'])
};
Label.defaultProps = {
  style: {},
  color: _core.colors.grey[600],
  variant: 'contained',
  shape: 'square'
};
var _default = Label;
exports["default"] = _default;